const constants = {
  dataURL:
    'https://s3.glbimg.com/v1/AUTH_08fb001c60b847468664307c11fa9dc9/static_especiais/futebol/brasileirao-serie-a/especial/avaliador-de-elencos-do-brasileirao-2025/data.json',
  //'./data/data.json',
  flags: {
    262: '\uD83C\uDDE9\uD83C\uDDEA',
    263: '\uD83C\uDDE6\uD83C\uDDF7',
    264: '\uD83C\uDDF8\uD83C\uDDE6',
    265: '\uD83C\uDDE7\uD83C\uDDF7',
    266: '\uD83C\uDDE7\uD83C\uDDEA',
    267: '\uD83C\uDDE8\uD83C\uDDF2',
    275: '\uD83C\uDDE8\uD83C\uDDE6',
    276: '\uD83C\uDDF6\uD83C\uDDE6',
    277: '\uD83C\uDDF0\uD83C\uDDF7',
    280: '\uD83C\uDFF4',
    282: '\uD83C\uDDED\uD83C\uDDF7',
    283: '\uD83C\uDDE9\uD83C\uDDF0',
    284: '\uD83C\uDDE6\uD83C\uDDFA',
    285: '\uD83C\uDDEA\uD83C\uDDE8',
    290: '\uD83C\uDDEA\uD83C\uDDF8',
    293: '\uD83C\uDDFA\uD83C\uDDF8',
    294: '\uD83C\uDDEB\uD83C\uDDF7',
    327: '\uD83C\uDDEC\uD83C\uDDED',
    356: '\uD83C\uDDF3\uD83C\uDDF1',
    1371: '\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F',
    2336: '\uD83C\uDDEE\uD83C\uDDF7',
    2369: '\uD83C\uDDEF\uD83C\uDDF5',
    2332: '\uD83C\uDDF2\uD83C\uDDE6',
    2360: '\uD83C\uDDF2\uD83C\uDDFD',
    2387: '\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F',
    2371: '\uD83C\uDDF5\uD83C\uDDF1',
    2390: '\uD83C\uDDF5\uD83C\uDDF9',
    2347: '\uD83C\uDDF8\uD83C\uDDF3',
    2320: '\uD83C\uDDE8\uD83C\uDDED',
    2605: '\uD83C\uDDF7\uD83C\uDDF8',
    2337: '\uD83C\uDDF9\uD83C\uDDF3',
    2356: '\uD83C\uDDFA\uD83C\uDDFE',
    2388: '\uD83C\uDDE8\uD83C\uDDF7',
  },
  eval: {
    6: {
      emoji: '⭐',
      title: 'Estrela',
    },
    5: {
      emoji: '❤️',
      title: 'Joga Muito',
    },
    4: {
      emoji: '😎',
      title: 'Agrega Valor',
    },
    3: {
      emoji: '🙂',
      title: 'Compõe elenco',
    },
    2: {
      emoji: '😡',
      title: 'Sujeito a vaias',
    },
    1: {
      emoji: '😒',
      title: 'Irrita a torcida',
    },
    question: {
      emoji: '❔',
      title: 'Sem avaliação',
    },
  },
  evalOrder: [6, 5, 4, 3, 2, 1],
  athletes: {
    title: 'Álbum de figurinhas',
    summary: 'Resumão da avaliação',
    evalStrings: ['ge', 'você', 'público'],
    buttonTitle: 'adicionar atletas',
  },
  tabs: ['ge.globo', 'minha avaliação'],
  getPlural: {
    athlete: (num) => `atleta${num === 1 ? '' : 's'}`,
    point: (num) => `pt${num === 1 ? '' : 's'}`,
  },
  share: {
    text: 'Compartilhar',
    title: 'Avaliação dos elencos do Brasileirão 2025',
    url: 'https://interativos.ge.globo.com/futebol/brasileirao-serie-a/especial/avaliador-de-elencos-do-brasileirao-2024',
  },
};

export default constants;
